import { ToggleContainer, ToggleButton } from './LinkToggle.styles';
import useActiveLink from '@/components/Link/hooks/useActiveLink';

const LinkToggle = ({ links }: { links: readonly Queries.LINKFragment[] }) => {
  let activeLinkId = useActiveLink({ links })?.system.id;

  // If no active link is found, default to the first link's ID
  if (!activeLinkId && links.length > 0) {
    activeLinkId = links[0].system.id;
  }

  return (
    <ToggleContainer>
      {links.map((link) => (
        <ToggleButton
          key={link.system.id}
          {...link}
          isActive={link.system.id === activeLinkId}
          aria-selected={link.system.id === activeLinkId}
        />
      ))}
    </ToggleContainer>
  );
};

export default LinkToggle;
